import { styled } from '@mui/material/styles';

const ReEngraveIcon = (props) => (
	<svg
		version="1.0"
		xmlns="http://www.w3.org/2000/svg"
		width={props.width || '512px'}
		height={props.height || '512px'}
		viewBox="0 0 512.000000 512.000000"
		preserveAspectRatio="xMidYMid meet"
		fill='#919EAB'
		{...props}
	>
		<g
			transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
			fill="#919EAB"
			stroke="none"
		>
			<path d="M1490 5052 c-19 -9 -40 -28 -47 -42 -10 -19 -13 -139 -13 -495 0 -664 -8 -637 277 -926 l183 -186 0 -175 0 -176 -80 -4 c-71 -3 -83 -6 -107 -31 l-28 -27 -3 -272 c-2 -193 0 -280 9 -300 17 -41 57 -58 137 -58 l69 0 7 -80 c8 -100 35 -173 89 -244 23 -31 140 -139 260 -241 263 -224 252 -220 368 -122 448 373 477 408 495 613 l7 74 68 0 c147 0 151 9 147 360 l-3 270 -28 27 c-24 25 -36 28 -107 31 l-80 4 0 176 0 175 183 186 c284 289 277 264 277 924 0 503 -1 511 -51 538 -38 20 -89 13 -118 -15 l-26 -26 -5 -503 -5 -502 -28 -59 c-22 -47 -63 -95 -199 -232 l-172 -174 -466 0 -466 0 -171 173 c-138 138 -177 184 -200 232 l-28 60 -5 502 -5 503 -25 24 c-35 33 -69 39 -110 18z m1420 -1857 l0 -145 -410 0 -410 0 0 145 0 145 410 0 410 0 0 -145z m220 -490 l0 -145 -630 0 -630 0 0 145 0 145 630 0 630 0 0 -145z m-223 -410 c-11 -113 -25 -131 -269 -339 l-138 -117 -167 144 c-93 79 -175 153 -184 163 -32 37 -50 85 -56 149 l-6 65 413 0 413 0 -6 -65z" />
			<path d="M1963 5055 c-65 -28 -64 -25 -61 -411 l3 -349 26 -56 c32 -68 82 -120 152 -157 l52 -27 365 0 365 0 52 27 c68 36 120 90 152 158 l26 55 3 345 c3 382 2 382 -60 413 -33 16 -40 16 -71 4 -68 -29 -67 -25 -67 -388 0 -323 0 -326 -23 -360 -40 -59 -41 -59 -389 -57 l-318 3 -32 33 -33 32 -5 344 c-5 376 -4 366 -67 393 -38 15 -30 15 -70 -2z" />
			<path d="M1699 1711 c-23 -23 -29 -38 -29 -72 0 -49 -1 -48 218 -236 131 -114 145 -123 183 -123 78 0 127 86 84 148 -15 21 -268 244 -329 290 -43 32 -90 29 -127 -7z" />
			<path d="M3185 1729 c-27 -16 -315 -267 -337 -293 -10 -12 -18 -38 -18 -62 0 -58 36 -94 95 -94 38 0 51 7 126 72 281 242 278 239 279 295 0 65 -88 115 -145 82z" />
			<path d="M2429 1431 l-29 -29 0 -361 0 -361 -1171 0 -1171 0 -29 -29 -29 -29 0 -249 c0 -276 1 -282 66 -309 50 -21 4938 -21 4989 0 65 27 66 35 63 316 l-3 252 -28 24 -28 24 -275 0 -276 0 -29 -29 c-54 -55 -29 -139 49 -161 20 -5 117 -10 215 -10 l177 0 0 -115 0 -115 -2360 0 -2360 0 0 115 0 115 1728 0 c1120 0 1740 4 1763 10 52 15 74 43 74 97 0 37 -5 49 -28 69 l-28 24 -554 0 -554 0 -3 366 -3 366 -28 24 c-41 35 -99 33 -138 -5z" />
			<path d="M1438 1124 c-57 -31 -66 -107 -19 -155 l29 -29 251 0 251 0 32 29 c27 24 33 36 33 71 0 35 -6 47 -33 71 l-32 29 -243 0 c-194 -1 -247 -4 -269 -16z" />
			<path d="M3031 1126 c-54 -30 -67 -106 -27 -153 l24 -28 248 -3 c175 -2 256 0 276 9 31 13 58 54 58 89 0 31 -29 76 -57 89 -37 17 -491 14 -522 -3z" />
			<path d="M4043 656 c-23 -20 -28 -32 -28 -71 0 -39 5 -51 28 -71 42 -36 99 -33 139 6 27 28 30 36 25 73 -11 82 -102 116 -164 63z" />
		</g>
	</svg>
);

const CssReEngraveSvg = styled(ReEngraveIcon)(({ theme }) => ({
	fill: theme.palette.text.secondary,
	height: 'auto',
	maxHeight: 'calc(1vh + 1.7vw)',
	width: '100%',
}));

export default CssReEngraveSvg;
